import { gql } from "@apollo/client";

export const GET_NOTIFICACIONES_CAMBIO_PROGRAMA = gql`
query GetNotificacionesCambioPrograma($idDelegacion: Int!, $idEstadoValidacion: Int!, $from: CustomDateTime!, $to: CustomDateTime!) {
    notificacionesCambioPrograma(
        idDelegacion: $idDelegacion,
        idEstadoValidacion: $idEstadoValidacion, 
        from: $from, 
        to: $to
    ) {
        success
        error
        valorEsperado {
            idEvaluacion
            idControlRI
            idDatosGenerales
            tipoNoticacion
            delegacion
            idDelegacion
            tipoEvaluacion
            idTipoModulo
            programa
            codSap
            cliente
            hC
            paciente
            estadoValidacion
            idMotivoNoIngreso
            motivoNoIngreso
            idMotivoDemora
            motivoDemora
            idMotivoRechazo
            motivoRechazo
            estadoRI
            estadoCoordinador
            profesionalASignado
            fechaLimite
            fechaRealizacion
            idMisTareas
            direccionRI
            observaciones
            franjaEtaria
            numeroDocumento
            fechaNacimiento
            edad
            telefonoContacto
            familiar
            familiarTelefono
            fechaNotificacion
            idProgramaACambiar
        }
    }
}`;